import { parseBoolVariable } from '@/helpers/envs';

const {
  NODE_ENV,
  VUE_APP_LOG_LEVEL: LOG_LEVEL,
  VUE_APP_SERVER_ENV: SERVER_ENV,
  VUE_APP_DEVTOOLS: devtools,
} = process.env;

const DEVTOOLS = parseBoolVariable(devtools);
const PRODUCTION_TIP = NODE_ENV === 'production';

export { NODE_ENV, LOG_LEVEL, SERVER_ENV, DEVTOOLS, PRODUCTION_TIP };
